(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    let bundlePropertiesWrapper = null; // scoped to main form after productForm is found

    function setBundlePropertiesEnabled(enabled) {
      if (!bundlePropertiesWrapper) return;

      bundlePropertiesWrapper
        .querySelectorAll('input')
        .forEach(function (input) {
          input.disabled = !enabled;
        });
    }
    const bundleVariant = document.querySelector('.bundle-variant');
    if (!bundleVariant) return;

    const singleCard = bundleVariant.querySelector('.single-product');
    const bundleCard = bundleVariant.querySelector('.bundle-product');

    if (singleCard && !singleCard.id) {
      singleCard.id = 'pdp-bundle-single-card';
    }

    if (bundleCard && !bundleCard.id) {
      bundleCard.id = 'pdp-bundle-bundle-card';
    }

    // Get bundle data from script tag
    const bundleDataScript = document.querySelector('#bundle-data-json');
    let bundleData = null;

    if (bundleDataScript) {
      try {
        bundleData = JSON.parse(bundleDataScript.textContent);
      } catch (e) {
        return;
      }
    }

    if (!bundleData || !bundleCard) return;

    // Track current mode
    let currentMode = 'single';

    window.__bundleTracking = {
      get mode() {
        return currentMode;
      },
      get variantId() {
        return currentMode === 'bundle'
          ? bundleData?.variant_id
          : originalValues.variantId;
      }
    };

    // Store original product values
    const originalValues = {
      title: null,
      price: null,
      description: null,
      images: [],
      variantId: null,
      sku: null,
      rawPrice: null,
      badge: undefined,
      formAction: null,
      productId: null,
      buttonText: null,
      buttonDataText: null,
      thumbsTemplate: null,
      thumbItems: []
    };

    // Find and store original product elements
    const productTitle = document.querySelector('.product__title, h1.product__title, [data-product-title]');
    const productPrice = document.querySelector('.product__price .price, .price__current, [data-product-price]');
    const priceWrapper = productPrice ? productPrice.closest('[data-price-wrapper]') : null;
    const productDescription = document.querySelector('.product__description, [data-product-description]');
    // .product__images is the outer wrapper div — imgs inside it are already covered by .product__slides img
    const productImages = document.querySelectorAll('.product__slides img, .product-single__photos img');
    const productForm = document.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;

    // Scope bundle-properties-wrapper to the main product form so the
    // product-bundle section's wrapper (which always needs its inputs enabled) is untouched.
    bundlePropertiesWrapper = productForm
      ? productForm.querySelector('.bundle-properties-wrapper')
      : document.querySelector('.bundle-properties-wrapper');

    // Find Add to Cart button and its text span - try multiple selectors
    var addToCartButton = document.querySelector('button[id^="AddToCart"]') || document.querySelector('[data-add-to-cart]');
    var addToCartBtn = null;
    if (addToCartButton) {
      addToCartBtn = addToCartButton.querySelector('.btn__text');
    }
    if (!addToCartBtn) {
      addToCartBtn = document.querySelector('.btn__text[data-add-to-cart-text]');
    }
    if (!addToCartBtn) {
      addToCartBtn = document.querySelector('[data-add-to-cart] .btn__text');
    }

    // Helper so we can re-find the CTA text element if needed
    function getAddToCartTextEl() {
      var btn = document.querySelector('button[id^="AddToCart"]') || document.querySelector('[data-add-to-cart]');
      if (!btn) return null;
      return btn.querySelector('.btn__text') || document.querySelector('.btn__text[data-add-to-cart-text]');
    }

    // Collect all variant inputs into an array - find ALL inputs with name="id" in any form
    const allVariantInputs = [];

    // Find ALL forms that might contain variant inputs
    document.querySelectorAll('form input[name="id"]').forEach(function(input) {
      if (allVariantInputs.indexOf(input) === -1) {
        allVariantInputs.push(input);
      }
    });

    // Also check for hidden inputs in product-form elements
    const productFormElements = document.querySelectorAll('product-form');
    productFormElements.forEach(function(formElement) {
      const form = formElement.querySelector('form');
      if (form) {
        const hiddenInputs = form.querySelectorAll('input[name="id"]');
        hiddenInputs.forEach(function(input) {
          if (allVariantInputs.indexOf(input) === -1) {
            allVariantInputs.push(input);
          }
        });
      }
    });

    // Store original values
    if (productTitle) originalValues.title = productTitle.textContent.trim();
    if (productPrice) originalValues.price = productPrice.textContent.trim();
    if (priceWrapper) originalValues.priceWrapperHtml = priceWrapper.innerHTML;
    if (productDescription) originalValues.description = productDescription.innerHTML;
    if (variantInput) originalValues.variantId = variantInput.value;

    // Seed sku/price for single mode from loyalty element data attributes
    var loyaltyEl = document.querySelector('loyalty-points-pdp');
    if (loyaltyEl) {
      originalValues.sku = loyaltyEl.getAttribute('data-sku') || null;
      var loyaltyPrice = loyaltyEl.getAttribute('data-price');
      if (loyaltyPrice) originalValues.rawPrice = parseFloat(loyaltyPrice);
    }
    if (productForm) {
      originalValues.formAction = productForm.action;
      const productIdInput = productForm.querySelector('input[name="product_id"]');
      if (productIdInput) {
        originalValues.productId = productIdInput.value;
      }
    }

    // Store original button text
    if (addToCartBtn) {
      originalValues.buttonText = addToCartBtn.textContent.trim();
      originalValues.buttonDataText = addToCartBtn.getAttribute('data-add-to-cart-text');
    }

    // Store original image sources and zoom data
    if (productImages.length > 0) {
      productImages.forEach(function(img) {
        var zoomContainer = img.closest('[data-zoom-image]');
        originalValues.images.push({
          src: img.src,
          srcset: img.srcset || '',
          parentLink: img.closest('a') ? img.closest('a').href : null,
          zoomSrc: zoomContainer ? zoomContainer.getAttribute('data-image-src') : null
        });
      });
    }

    // Store original thumbnails template for zoom modal
    var thumbsTemplate = document.querySelector('[data-pswp-thumbs-template]');
    if (thumbsTemplate) {
      originalValues.thumbsTemplate = thumbsTemplate.innerHTML;
    }

    // Store original thumbnail item images so we can restore them
    document.querySelectorAll('.product__thumbs [data-thumb-item]').forEach(function(item) {
      const img = item.querySelector('img');
      const link = item.querySelector('[data-thumb-link]');
      originalValues.thumbItems.push({
        el: item, img: img, link: link,
        src: img ? img.src : '',
        srcset: img ? (img.srcset || '') : '',
        alt: img ? (img.alt || '') : '',
        href: link ? link.href : ''
      });
    });

    // Set initial state (Single mode active)
    if (singleCard) singleCard.classList.add('active');

    setBundlePropertiesEnabled(false);

    
    // Hide "What's Inside" section on initial load
    const whatsInsideSection = document.querySelector('[data-whats-inside]');
    if (whatsInsideSection) {
      whatsInsideSection.style.display = 'none';
    }

    // Keep the single variantId in sync with actual selection
    document.addEventListener('theme:variant:change', function(event) {
      if (currentMode !== 'single') return;

      const v = event.detail && event.detail.variant;
      if (!v || !v.id) return;

      originalValues.variantId = String(v.id);
      if (v.sku != null) originalValues.sku = v.sku;
      if (v.price != null) originalValues.rawPrice = v.price;

      // --- CHANGE: also capture the latest CTA text after variant changes (if theme updates it here) ---
      var liveBtnTextEl = addToCartBtn || getAddToCartTextEl();
      if (liveBtnTextEl) {
        originalValues.buttonText = liveBtnTextEl.textContent.trim();
        originalValues.buttonDataText = liveBtnTextEl.getAttribute('data-add-to-cart-text');
      }
    });

    // --- CHANGE: MutationObserver keeps CTA text in sync in single mode ---
    (function attachCtaObserver() {
      var liveBtnTextEl = addToCartBtn || getAddToCartTextEl();
      if (!liveBtnTextEl || typeof MutationObserver === 'undefined') return;

      var ctaObserver = new MutationObserver(function() {
        if (currentMode !== 'single') return;

        originalValues.buttonText = liveBtnTextEl.textContent.trim();
        originalValues.buttonDataText = liveBtnTextEl.getAttribute('data-add-to-cart-text');
      });

      ctaObserver.observe(liveBtnTextEl, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-add-to-cart-text']
      });
    })();

    // Single card click handler
    if (singleCard) {
      singleCard.addEventListener('click', function() {
        setMode('single', originalValues);
      });
    }

    // Bundle card click handler
    if (bundleCard) {
      bundleCard.addEventListener('click', function() {
        setMode('bundle', bundleData);
      });
    }

    // Only force variant inputs in bundle mode
    function updateVariantInputs() {
      if (currentMode !== 'bundle') return;

      if (bundleData && bundleData.variant_id) {
        allVariantInputs.forEach(function(input) {
          input.value = bundleData.variant_id;
        });
      }
    }

    // Intercept form submission to ensure correct variant ID is used
    if (productForm) {
      productForm.addEventListener('submit', function(e) {

        if (currentMode === 'single') {
          setBundlePropertiesEnabled(false);
        } else {
          setBundlePropertiesEnabled(true);
        }

        updateVariantInputs();
      });
    }


    // Also handle product-form custom element submissions
    productFormElements.forEach(function(formElement) {
      formElement.addEventListener('submit', function(e) {
        if (currentMode === 'single') {
          setBundlePropertiesEnabled(false);
          } else {
          setBundlePropertiesEnabled(true);
          }
        updateVariantInputs();
      });
    });

    // Add click handler on Add to Cart button to set variant before any other handlers
    var addToCartButton2 = document.querySelector('[data-add-to-cart]');
    if (addToCartButton2) {
      addToCartButton2.addEventListener('click', function() {
        updateVariantInputs();
      }, true);
    }

    // Inject __bundle_* properties so Cart Transform can expand the bundle
    function injectBundleVariants(body) {
      var variants = bundleData && bundleData.bundle_variants;
      if (!variants) return body;
      variants.forEach(function(variantId, index) {
        if (!variantId) return;
        var key = 'properties[__bundle_' + (index + 1) + ']';
        if (body instanceof FormData) {
          body.set(key, String(variantId));
        } else if (typeof body === 'string') {
          body += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(variantId);
        }
      });
      return body;
    }

    // Intercept fetch requests to /cart/add to ensure correct variant ID
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (currentMode === 'bundle' && bundleData && bundleData.variant_id) {
        var urlStr = typeof url === 'string' ? url : url.url;
        if (urlStr && urlStr.includes('/cart/add')) {
          if (options && options.body) {
            var body = options.body;

            // Handle FormData
            if (body instanceof FormData) {
              body.set('id', bundleData.variant_id);
              injectBundleVariants(body);
            }
            // Handle URL encoded string
            else if (typeof body === 'string') {
              body = body.replace(/id=\d+/, 'id=' + bundleData.variant_id);
              body = injectBundleVariants(body);
              options.body = body;
            }
            // Handle JSON
            else if (typeof body === 'object') {
              try {
                var jsonBody = JSON.parse(body);
                jsonBody.id = bundleData.variant_id;
                if (!jsonBody.properties) jsonBody.properties = {};
                var variants = bundleData.bundle_variants;
                if (variants) {
                  variants.forEach(function(variantId, index) {
                    if (variantId) jsonBody.properties['__bundle_' + (index + 1)] = variantId;
                  });
                }
                options.body = JSON.stringify(jsonBody);
              } catch(e) {}
            }
          }
        }
      }
      return originalFetch.apply(this, arguments);
    };

    // Also intercept XMLHttpRequest for older AJAX calls
    var originalXHROpen = XMLHttpRequest.prototype.open;
    var originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url) {
      this._bundleUrl = url;
      return originalXHROpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body) {
      if (currentMode === 'bundle' && bundleData && bundleData.variant_id) {
        if (this._bundleUrl && this._bundleUrl.includes('/cart/add')) {
          if (typeof body === 'string') {
            body = body.replace(/id=\d+/, 'id=' + bundleData.variant_id);
            body = injectBundleVariants(body);
          }
        }
      }
      return originalXHRSend.call(this, body);
    };

    function fireThemeVariantChange(variantId) {
      const mainInput = variantInput || allVariantInputs[0];
      if (mainInput) {
        mainInput.value = String(variantId);
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      document.dispatchEvent(new CustomEvent('theme:variant:change', {
        detail: { variant: { id: Number(variantId) } }
      }));
    }

    function setMode(mode, data) {
      
      // Capture current variant state BEFORE switching to bundle
      if (mode === 'bundle' && currentMode === 'single') {
        const currentVariantInput = variantInput || allVariantInputs[0];
        if (currentVariantInput) {
          originalValues.variantId = currentVariantInput.value;
        }

        if (productPrice) {
          originalValues.price = productPrice.textContent.trim();
        }

        if (productTitle) {
          originalValues.title = productTitle.textContent.trim();
        }

        // Capture CTA text right before switching too
        var liveBtnTextEl = addToCartBtn || getAddToCartTextEl();
        if (liveBtnTextEl) {
          originalValues.buttonText = liveBtnTextEl.textContent.trim();
          originalValues.buttonDataText = liveBtnTextEl.getAttribute('data-add-to-cart-text');
        }
      }

      // Update current mode
      currentMode = mode;

      // Update card states
      if (singleCard) singleCard.classList.toggle('active', mode === 'single');
      if (bundleCard) bundleCard.classList.toggle('active', mode === 'bundle');

      if (mode === 'bundle') {
        document.body.classList.add('bundle-product-active');
      } else {
        document.body.classList.remove('bundle-product-active');
      }

      if (mode === 'single') {

        setBundlePropertiesEnabled(false);

        // Restore original product values
        if (productTitle && originalValues.title) {
          productTitle.textContent = originalValues.title;
        }

        if (priceWrapper && originalValues.priceWrapperHtml) {
          priceWrapper.innerHTML = originalValues.priceWrapperHtml;
        } else if (productPrice && originalValues.price) {
          productPrice.textContent = originalValues.price;
        }

        if (productDescription && originalValues.description) {
          productDescription.innerHTML = originalValues.description;
        }
        if (productForm && originalValues.formAction) {
          productForm.action = originalValues.formAction;
        }

        // Restore original button text (now kept in sync by the observer)
        var btnTextElement = addToCartBtn || getAddToCartTextEl();

        // Old logic that re-finds the button
        // Leaving it here but it should be redundant now
        if (!btnTextElement) {
          var btn = document.querySelector('button[id^="AddToCart"]') || document.querySelector('[data-add-to-cart]');
          if (btn) btnTextElement = btn.querySelector('.btn__text');
          if (!btnTextElement) btnTextElement = document.querySelector('.btn__text[data-add-to-cart-text]');
        }

        if (btnTextElement && originalValues.buttonText) {
          btnTextElement.textContent = originalValues.buttonText;
          if (originalValues.buttonDataText) {
            btnTextElement.setAttribute('data-add-to-cart-text', originalValues.buttonDataText);
          }
        }

        // Do not force variant input in single mode
        // allVariantInputs.forEach(function(input) {
        //   input.value = originalValues.variantId;
        // });

        // Do not force a variant change event in single mode
        // if (originalValues.variantId) {
        //   fireThemeVariantChange(originalValues.variantId);
        // }

        // Restore original product images and show all hidden containers
        if (productImages.length > 0 && originalValues.images.length > 0) {
          productImages.forEach(function(img, index) {
            var imageContainer = img.closest('.product__slide, .product__photo, .product__image-wrapper, li, [class*="slide"]');
            if (imageContainer) {
              imageContainer.style.display = '';
            }
            img.style.display = '';

            if (originalValues.images[index]) {
              img.src = originalValues.images[index].src;
              img.srcset = originalValues.images[index].srcset;
              var link = img.closest('a');
              if (link && originalValues.images[index].parentLink) {
                link.href = originalValues.images[index].parentLink;
              }
              var zoomContainer = img.closest('[data-zoom-image]');
              if (zoomContainer && originalValues.images[index].zoomSrc) {
                zoomContainer.setAttribute('data-image-src', originalValues.images[index].zoomSrc);
              }
            }
          });
        }

        // Restore all thumbnail items with original images
        originalValues.thumbItems.forEach(function(t) {
          t.el.style.display = '';
          if (t.img) { t.img.src = t.src; t.img.srcset = t.srcset; t.img.alt = t.alt; }
          if (t.link) { t.link.href = t.href; }
        });

        // Restore original thumbnails template for zoom modal
        if (thumbsTemplate && originalValues.thumbsTemplate) {
          thumbsTemplate.innerHTML = originalValues.thumbsTemplate;
        }

        // Hide "What's Inside" section
        const whatsInsideSection2 = document.querySelector('[data-whats-inside]');
        if (whatsInsideSection2) {
          whatsInsideSection2.style.display = 'none';
        }

        // Show review card wrapper in single mode
        const reviewCardWrapper = document.querySelector('.review-card-wrapper');
        if (reviewCardWrapper) {
          reviewCardWrapper.style.display = '';
        }
        const dataProductVariants = document.querySelector('[data-product-variants]');
        if (dataProductVariants) {
          dataProductVariants.style.display = '';
        }
        const yotpoWidget = document.querySelector('.product__content .yotpo-widget-instance');
        if (yotpoWidget) {
          yotpoWidget.style.display = '';
        }

        const keyIngredientsBlock = document.querySelector('.key-ingredients-block');
        if (keyIngredientsBlock) {
          keyIngredientsBlock.style.display = '';
        }
        const pricePerMl = document.querySelector('[data-price-per-ml]');
        if (pricePerMl) {
          pricePerMl.style.display = '';
        }
        const mainSubsWrapper = document.querySelector('.main-subs-wrapper');
        if (mainSubsWrapper) {
          mainSubsWrapper.style.display = '';
        }
        document.querySelectorAll('.product__custom-code').forEach(function(el) {
          el.style.display = '';
        });
        var badgeBox = document.querySelector('.product__badges .badge-box');
        if (badgeBox && originalValues.badge !== undefined) {
          if (originalValues.badge) {
            badgeBox.textContent = originalValues.badge;
            badgeBox.style.display = '';
          } else {
            badgeBox.style.display = 'none';
          }
        }
      } else {

        setBundlePropertiesEnabled(true);

        // Replace with bundle values
        if (productTitle && data.title) {
          productTitle.textContent = data.title;
        }

        if (priceWrapper && data.bundle_price) {
          if (data.bundle_compare_at_price) {
            priceWrapper.innerHTML = '<span data-product-price class="product__price--sale swipe-sale">' + escapeHtml(data.bundle_price) + '</span> <s class="product__price--strike" data-compare-price>' + escapeHtml(data.bundle_compare_at_price) + '</s>';
          } else {
            priceWrapper.innerHTML = '<span data-product-price>' + escapeHtml(data.bundle_price) + '</span>';
          }
        } else if (productPrice && data.bundle_price) {
          productPrice.textContent = data.bundle_price;
        }
        if (productDescription && data.short_description) {
          productDescription.innerHTML = `<div class="product__description__content rte">${data.short_description}</div>`;
        }
        if (productForm && data.variant_id) {
          productForm.action = '/cart/add';
        }

        // Update button text with bundle price
        var btnTextElement2 = addToCartBtn || getAddToCartTextEl();
        if (!btnTextElement2) {
          var btn2 = document.querySelector('button[id^="AddToCart"]') || document.querySelector('[data-add-to-cart]');
          if (btn2) btnTextElement2 = btn2.querySelector('.btn__text');
          if (!btnTextElement2) btnTextElement2 = document.querySelector('.btn__text[data-add-to-cart-text]');
        }

        if (btnTextElement2 && data.bundle_price) {
          var addToCartLabel = decodeHtml(data.add_to_cart_label || 'Add to bag');
          var newButtonText = addToCartLabel + ' - ' + data.bundle_price;
          btnTextElement2.textContent = newButtonText;
          btnTextElement2.setAttribute('data-add-to-cart-text', newButtonText);
        }

        // Force bundle variant id everywhere
        allVariantInputs.forEach(function(input) {
          input.value = data.variant_id;
        });

        // Update product images with bundle hero image and product images
        if (productImages.length > 0) {
          var bundleImageCount = 1 + (data.whats_inside ? data.whats_inside.length : 0);

          productImages.forEach(function(img, index) {
            var imageContainer = img.closest('.product__slide, .product__photo, .product__image-wrapper, li, [class*="slide"]');
            var zoomContainer = img.closest('[data-zoom-image]');

            if (index === 0 && data.hero_image) {
              img.src = data.hero_image;
              img.srcset = '';
              var link = img.closest('a');
              if (link) link.href = data.hero_image;
              if (imageContainer) imageContainer.style.display = '';
              if (zoomContainer) {
                zoomContainer.setAttribute('data-image-src', data.hero_image);
              }
            } else if (data.whats_inside && data.whats_inside[index - 1]) {
              var item = data.whats_inside[index - 1];
              var galleryImage = item.gallery_image || item.image;
              var zoomImage = item.zoom_image || galleryImage;

              if (galleryImage) {
                img.src = galleryImage;
                img.srcset = '';
                var link2 = img.closest('a');
                if (link2) link2.href = galleryImage;
                if (imageContainer) imageContainer.style.display = '';
                if (zoomContainer) {
                  zoomContainer.setAttribute('data-image-src', zoomImage);
                }
              }
            } else if (index >= bundleImageCount) {
              if (imageContainer) {
                imageContainer.style.display = 'none';
              } else {
                img.style.display = 'none';
              }
            }
          });

          // Update thumb images to match bundle images, hide excess
          originalValues.thumbItems.forEach(function(t, index) {
            if (index >= bundleImageCount) { t.el.style.display = 'none'; return; }
            let src, alt;
            if (index === 0) {
              src = data.hero_image || '';
              alt = data.title || '';
            } else {
              const wi = data.whats_inside && data.whats_inside[index - 1];
              src = (wi && (wi.gallery_image || wi.image)) || '';
              alt = (wi && wi.title) || '';
            }
            if (!src) { t.el.style.display = 'none'; return; }
            t.el.style.display = '';
            if (t.img) { t.img.src = src; t.img.srcset = ''; t.img.alt = alt; }
            if (t.link) { t.link.href = src; }
          });
        }

        // Update thumbnails template for zoom modal with bundle images
        if (thumbsTemplate && data.whats_inside) {
          var thumbsHtml = '';
          if (data.hero_image) {
            thumbsHtml += '<img class="pswp__thumb" src="' + data.hero_image.replace(/width=\\d+/, 'width=160') + '" width="80" height="80" loading="lazy" alt="Bundle">';
          }
          data.whats_inside.forEach(function(item, index) {
            if (item.image) {
              var thumbSrc = item.image.replace(/width=\\d+/, 'width=160');
              thumbsHtml += '<img class="pswp__thumb" src="' + thumbSrc + '" width="80" height="80" loading="lazy" alt="' + (item.title || 'Product ' + (index + 1)) + '">';
            }
          });
          thumbsTemplate.innerHTML = thumbsHtml;
        }

        // Add "What's Inside" section if it doesn't exist
        addWhatsInsideSection(data);

        // Hide review card wrapper in bundle mode
        const reviewCardWrapper2 = document.querySelector('.review-card-wrapper');
        if (reviewCardWrapper2) {
          reviewCardWrapper2.style.display = 'none';
        }

        const yotpoWidget2 = document.querySelector('.product__content .yotpo-widget-instance');
        if (yotpoWidget2) {
          yotpoWidget2.style.display = 'none';
        }

        const pricePerMl2 = document.querySelector('[data-price-per-ml]');
        if (pricePerMl2) {
          pricePerMl2.style.display = 'none';
        }
        const dataProductVariants2 = document.querySelector('[data-product-variants]');
        if (dataProductVariants2) {
          dataProductVariants2.style.display = 'none';
        }
        const keyIngredientsBlock2 = document.querySelector('.key-ingredients-block');
        if (keyIngredientsBlock2) {
          keyIngredientsBlock2.style.display = 'none';
        }
        const mainSubsWrapper2 = document.querySelector('.main-subs-wrapper');
        if (mainSubsWrapper2) {
          mainSubsWrapper2.style.display = 'none';
        }
        document.querySelectorAll('.product__custom-code').forEach(function(el) {
          el.style.display = 'none';
        });
        var badgeBox2 = document.querySelector('.product__badges .badge-box');
        if (badgeBox2) {
          originalValues.badge = badgeBox2.textContent.trim();
          if (data.badge) {
            badgeBox2.textContent = data.badge;
            badgeBox2.style.display = '';
          } else {
            badgeBox2.style.display = 'none';
          }
        }
      }

      // Dispatch bundle mode change
      document.dispatchEvent(new CustomEvent('bundle:mode:change', {
        detail: { mode: mode }
      }));

      // Fire theme:variant:change after a tick so any theme-triggered variant
      // events settle first, then we override with the correct SKU and price
      if (mode === 'bundle' && bundleData && bundleData.sku) {
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('theme:variant:change', {
            detail: { variant: { id: Number(bundleData.variant_id), sku: bundleData.sku, price: bundleData.raw_price } }
          }));
        }, 0);
      } else if (mode === 'single' && originalValues.sku) {
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('theme:variant:change', {
            detail: { variant: { id: Number(originalValues.variantId), sku: originalValues.sku, price: originalValues.rawPrice } }
          }));
        }, 0);
      }
    }

    function addWhatsInsideSection(data) {
      if (!data.whats_inside || data.whats_inside.length === 0) return;

      let whatsInsideSection = document.querySelector('[data-whats-inside]');
      const loyaltyPointsPdp = document.querySelector('.loyalty-points-guest__text');

      if (!whatsInsideSection) {
        whatsInsideSection = document.createElement('div');
        whatsInsideSection.className = 'bundle-whats-inside';
        whatsInsideSection.setAttribute('data-whats-inside', '');

        let html = '<h2 class="bundle-whats-inside__title">' + escapeHtml(decodeHtml(data.whats_inside_title || 'What\'s Inside')) + '</h2>';
        html += '<ul class="bundle-whats-inside__list">';

        data.whats_inside.forEach(function(item) {
          if (item.image || item.title) {
            html += `
              <li class="bundle-whats-inside__item">
                <div class="bundle-whats-inside__item-image">
                  ${item.image ? (item.url ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title || '')}" loading="lazy"></a>` : `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title || '')}" loading="lazy">`) : ''}
                </div>
                ${item.url ? `<a href="${escapeHtml(item.url)}" class="bundle-whats-inside__item-content">` : '<div class="bundle-whats-inside__item-content">'}
                  ${item.subheading ? `<p class="bundle-whats-inside__item-subheading">${escapeHtml(item.subheading)}</p>` : ''}
                  <div class="bundle-whats-inside__item-title-size-wrapper">
                    ${item.title ? `<p class="bundle-whats-inside__item-title">${escapeHtml(item.title)}</p>` : ''}
                    ${item.size ? `<div class="bundle-whats-inside__item-size">${escapeHtml(item.size)}</div>` : ''}
                  </div>
                  ${item.cutline ? `<p class="bundle-whats-inside__item-cutline">${escapeHtml(item.cutline)}</p>` : ''}
                ${item.url ? '</a>' : '</div>'}
              </li>
            `;
          }
        });

        html += '</ul>';
        whatsInsideSection.innerHTML = html;

        var variantsBlock = document.querySelector('[data-product-variants]');
        if (variantsBlock && variantsBlock.parentNode) {
          variantsBlock.parentNode.insertBefore(whatsInsideSection, variantsBlock.nextSibling);
        } else if (loyaltyPointsPdp && loyaltyPointsPdp.parentNode) {
          loyaltyPointsPdp.parentNode.insertBefore(whatsInsideSection, loyaltyPointsPdp.nextSibling);
        } else if (productDescription && productDescription.parentNode) {
          productDescription.parentNode.insertBefore(whatsInsideSection, productDescription.nextSibling);
        }
      } else {
        whatsInsideSection.style.display = 'block';
      }
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Translations from Liquid's `t` filter arrive HTML-escaped (e.g. What&#39;s Inside)
    function decodeHtml(text) {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text;
      return textarea.value;
    }

    

  }
})();
